define('OutSystems/ClientRuntime/ApplicationInfo',["require", "exports", "./Transitions"], function (require, exports, Transitions) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getBasePath = exports.moduleBelongsToApp = exports.showWatermark = exports.isWebApplication = exports.getErrorPageConfig = exports.getDefaultTransition = exports.setApplicationDefaultTimeout = exports.getApplicationDefaultTimeout = exports.getHomeModuleLanguageResourcesName = exports.getHomeModuleControllerName = exports.isDebugEnabled = exports.getUserProviderName = exports.getUserCookieName = exports.getDefaultModuleHomeScreenURL = exports.getScreenDefinitionFromScreenName = exports.getScreenDefinition = exports.getHomeModuleDefinition = exports.getHomeModuleKey = exports.getHomeModuleName = exports.setDatabaseName = exports.setClientEntitiesModules = exports.getClientEntitiesModules = exports.getHomeScreen = exports.getModuleFromKey = exports.getModules = exports.setModules = exports.getDatabaseName = exports.getApplicationName = exports.getApplicationKey = exports.getEnvironmentName = exports.getEnvironmentKey = exports.setApplicationDefinition = void 0;
    var appDefinition = {
        environmentKey: "",
        environmentName: "",
        applicationKey: "",
        applicationName: "",
        userProviderName: "",
        debugEnabled: false,
        homeModuleName: "",
        homeModuleKey: "",
        modules: {},
        homeModuleControllerName: "",
        homeModuleLanguageResourcesName: "",
        clientEntitiesModules: [],
        applicationDefaultTimeout: null,
        isWeb: false,
        showWatermark: false,
    };
    function setApplicationDefinition(newApplicationDefinition) {
        appDefinition = newApplicationDefinition;
    }
    exports.setApplicationDefinition = setApplicationDefinition;
    function getEnvironmentKey() {
        return appDefinition.environmentKey;
    }
    exports.getEnvironmentKey = getEnvironmentKey;
    function getEnvironmentName() {
        return appDefinition.environmentName;
    }
    exports.getEnvironmentName = getEnvironmentName;
    function getApplicationKey() {
        return appDefinition.applicationKey;
    }
    exports.getApplicationKey = getApplicationKey;
    function getApplicationName() {
        return appDefinition.applicationName;
    }
    exports.getApplicationName = getApplicationName;
    function getDatabaseName() {
        return appDefinition.databaseName;
    }
    exports.getDatabaseName = getDatabaseName;
    function setModules(modules) {
        appDefinition.modules = modules;
    }
    exports.setModules = setModules;
    function getModules() {
        return appDefinition.modules;
    }
    exports.getModules = getModules;
    function getModuleFromKey(moduleKey) {
        var modules = appDefinition.modules;
        var moduleDefinition = modules[moduleKey];
        if (!moduleDefinition) {
            modules[moduleKey] = {
                moduleName: null,
                homeScreenName: null,
                splashScreenName: null,
                screens: [],
                staticEntities: {},
            };
        }
        return modules[moduleKey];
    }
    exports.getModuleFromKey = getModuleFromKey;
    function getHomeScreen(module) {
        if (module.homeScreenName) {
            return getScreenDefinitionFromScreenName(module, module.homeScreenName);
        }
        if (module.screens && module.screens.length > 0) {
            return module.screens[0];
        }
        return null;
    }
    exports.getHomeScreen = getHomeScreen;
    function getClientEntitiesModules() {
        return appDefinition.clientEntitiesModules;
    }
    exports.getClientEntitiesModules = getClientEntitiesModules;
    function setClientEntitiesModules(moduleNames) {
        appDefinition.clientEntitiesModules = moduleNames;
    }
    exports.setClientEntitiesModules = setClientEntitiesModules;
    function setDatabaseName(databaseName) {
        appDefinition.databaseName = databaseName;
    }
    exports.setDatabaseName = setDatabaseName;
    function getHomeModuleName() {
        return appDefinition.homeModuleName;
    }
    exports.getHomeModuleName = getHomeModuleName;
    function getHomeModuleKey() {
        return appDefinition.homeModuleKey;
    }
    exports.getHomeModuleKey = getHomeModuleKey;
    function getHomeModuleDefinition() {
        if (appDefinition.homeModuleName && appDefinition.modules) {
            var homeModule = appDefinition.modules[appDefinition.homeModuleKey];
            return !!homeModule ? homeModule : null;
        }
        return null;
    }
    exports.getHomeModuleDefinition = getHomeModuleDefinition;
    function getScreenDefinition(moduleDefinition, screenUrl) {
        for (var _i = 0, _a = moduleDefinition.screens; _i < _a.length; _i++) {
            var screen_1 = _a[_i];
            if (screen_1.screenUrl === screenUrl) {
                return screen_1;
            }
        }
        return null;
    }
    exports.getScreenDefinition = getScreenDefinition;
    function getScreenDefinitionFromScreenName(moduleDefinition, screenName) {
        for (var _i = 0, _a = moduleDefinition.screens; _i < _a.length; _i++) {
            var screen_2 = _a[_i];
            if (screen_2.screenName === screenName) {
                return screen_2;
            }
        }
        return null;
    }
    exports.getScreenDefinitionFromScreenName = getScreenDefinitionFromScreenName;
    function getDefaultModuleHomeScreenURL() {
        var moduleDefinition = getHomeModuleDefinition();
        var homeScreen = getHomeScreen(moduleDefinition);
        return homeScreen ? "/" + moduleDefinition.moduleName + "/" + homeScreen.screenUrl : null;
    }
    exports.getDefaultModuleHomeScreenURL = getDefaultModuleHomeScreenURL;
    function getUserCookieName() {
        return "nr2" + appDefinition.userProviderName;
    }
    exports.getUserCookieName = getUserCookieName;
    function getUserProviderName() {
        return appDefinition.userProviderName;
    }
    exports.getUserProviderName = getUserProviderName;
    function isDebugEnabled() {
        return appDefinition.debugEnabled;
    }
    exports.isDebugEnabled = isDebugEnabled;
    function getHomeModuleControllerName() {
        return appDefinition.homeModuleControllerName;
    }
    exports.getHomeModuleControllerName = getHomeModuleControllerName;
    function getHomeModuleLanguageResourcesName() {
        return appDefinition.homeModuleLanguageResourcesName;
    }
    exports.getHomeModuleLanguageResourcesName = getHomeModuleLanguageResourcesName;
    function getApplicationDefaultTimeout() {
        return appDefinition.applicationDefaultTimeout;
    }
    exports.getApplicationDefaultTimeout = getApplicationDefaultTimeout;
    function setApplicationDefaultTimeout(applicationDefaultTimeout) {
        appDefinition.applicationDefaultTimeout = applicationDefaultTimeout;
    }
    exports.setApplicationDefaultTimeout = setApplicationDefaultTimeout;
    function getDefaultTransition() {
        var transitionAnimation = Transitions.TransitionAnimation[appDefinition.defaultTransition];
        return Transitions.createTransition(transitionAnimation);
    }
    exports.getDefaultTransition = getDefaultTransition;
    function getErrorPageConfig() {
        return appDefinition.errorPageConfig;
    }
    exports.getErrorPageConfig = getErrorPageConfig;
    function isWebApplication() {
        return appDefinition.isWeb;
    }
    exports.isWebApplication = isWebApplication;
    function showWatermark() {
        return appDefinition.showWatermark;
    }
    exports.showWatermark = showWatermark;
    function moduleBelongsToApp(moduleName) {
        var _a;
        var targetModule = Object.keys(appDefinition.modules)
            .map(function (key) { return appDefinition.modules[key]; })
            .filter(function (module) { return module.moduleName === moduleName; });
        return ((_a = targetModule[0]) === null || _a === void 0 ? void 0 : _a.ownerAppKey) === getApplicationKey();
    }
    exports.moduleBelongsToApp = moduleBelongsToApp;
    function getBasePath(_a) {
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, _e = _d.applicationHomeModule, applicationHomeModule = _e === void 0 ? getHomeModuleName : _e;
        var globalObject = typeof window !== "undefined" ? window : global;
        var basePath = (_c = (_b = globalObject.OutSystemsApp) === null || _b === void 0 ? void 0 : _b.basePath) !== null && _c !== void 0 ? _c : applicationHomeModule();
        return ("/" + basePath + "/").replace(/\/(\/)+/gm, "/");
    }
    exports.getBasePath = getBasePath;
});
//# sourceMappingURL=ApplicationInfo.js.map;
